function DatabaseIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
    >
      <g>
        <path d="M24 20c-11.215 0-20-3.953-20-9s8.785-9 20-9 20 3.953 20 9-8.785 9-20 9zm0-16C15.486 4 6 6.875 6 11s9.486 7 18 7 18-2.875 18-7-9.486-7-18-7z"></path>
        <path d="M24 28c-11.215 0-20-3.953-20-9v-8a1 1 0 112 0v8c0 4.125 9.486 7 18 7s18-2.875 18-7v-8a1 1 0 112 0v8c0 5.047-8.785 9-20 9z"></path>
        <path d="M24 37c-11.215 0-20-3.953-20-9v-9a1 1 0 112 0v9c0 4.125 9.486 7 18 7s18-2.875 18-7v-9a1 1 0 112 0v9c0 5.047-8.785 9-20 9z"></path>
        <path d="M24 46c-11.215 0-20-3.953-20-9v-9a1 1 0 112 0v9c0 4.125 9.486 7 18 7s18-2.875 18-7v-9a1 1 0 112 0v9c0 5.047-8.785 9-20 9z"></path>
      </g>
    </svg>
  );
}

export default DatabaseIcon;
